module.exports = __webpack_public_path__ + "img/video-pitch-icon.ebb0a0e8.svg";